export default __webpack_public_path__ + "static/floor2-slide-3-c30a6f2a0c67a502e89f2695198c134e.jpg";